import { render, staticRenderFns } from "./PersonalBalanceIncomeLiabilities.vue?vue&type=template&id=7ebc07be"
import script from "./PersonalBalanceIncomeLiabilities.vue?vue&type=script&lang=js"
export * from "./PersonalBalanceIncomeLiabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports